/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MeevoBi {
    "use strict";

    export class MeevoBiContext extends Meevo.Components.CommonClasses.CommonContextBase {

        protected loading: boolean;
        //public auditNoun = Meevo.Model.NounEnum.MeevoBi;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            businessInfoDataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected identityDataService: Meevo.Components.Common.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $http: angular.IHttpService) {
            super(appSettings, businessInfoDataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.meevoBi;
            this.sectionTemplatePath = "app/plugins/meevoBi/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.INTEGRATION_MEEVOBI_TAB_MAIN);
            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_MEEVOBI_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(
                    0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    true,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.MeevoBI,
                    this.identityService,
                    this.appSettings,
                    this.modalService,
                    this.securityKeys.INTEGRATION_MEEVOBI_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
            this.activate();
        }

        initializeHeader(model: any): void {
        }

        //get currentAveda(): Model.MeevoBi {
        //    return this.castModel<Model.MeevoBi>();
        //}
        protected castModel<T>(): T {
            return this.verifySelectedSectionModel() ? <T>this.selectedSection.model : undefined;
        }

        public verifySelectedSectionModel(): boolean {
            return Model.Guard.isSomething(this.selectedSection)
                && Model.Guard.isSomething(this.selectedSection.model);
        }

    }
}

